import React, { useState, useEffect } from 'react';
import { authAPI } from '../services/api';
import './ProfileModal.css';

const ProfileModal = ({ isOpen, onClose }) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      loadProfile();
    }
  }, [isOpen]);

  const loadProfile = async () => {
    try {
      setLoading(true);
      const response = await authAPI.getProfile();
      setProfile(response.data);
    } catch (error) {
      console.error('Error loading profile:', error);
      alert('Failed to load profile');
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    return `LKR ${parseFloat(amount || 0).toLocaleString('en-LK', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="profile-modal">
        <div className="modal-header">
          <h2>Employee Profile</h2>
          <button className="close-modal" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-content">
          {loading ? (
            <div className="loading">Loading profile...</div>
          ) : profile ? (
            <div className="profile-details">
              <div className="profile-section">
                <h3>Personal Information</h3>
                <div className="detail-row">
                  <span className="label">Full Name:</span>
                  <span className="value">{profile.full_legal_name}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Employee ID:</span>
                  <span className="value">{profile.employee_id}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Role:</span>
                  <span className="value">{profile.user_role}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Email:</span>
                  <span className="value">{profile.email}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Contact:</span>
                  <span className="value">{profile.contact_number}</span>
                </div>
              </div>

              <div className="profile-section">
                <h3>Employment Details</h3>
                <div className="detail-row">
                  <span className="label">Hire Date:</span>
                  <span className="value">{new Date(profile.hire_date).toLocaleDateString()}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Employment Type:</span>
                  <span className="value">{profile.employment_type}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Work Schedule:</span>
                  <span className="value">{profile.work_schedule}</span>
                </div>
                {profile.hourly_wage && (
                  <div className="detail-row">
                    <span className="label">Hourly Wage:</span>
                    <span className="value">{formatCurrency(profile.hourly_wage)}</span>
                  </div>
                )}
                {profile.monthly_salary && (
                  <div className="detail-row">
                    <span className="label">Monthly Salary:</span>
                    <span className="value">{formatCurrency(profile.monthly_salary)}</span>
                  </div>
                )}
              </div>

              <div className="profile-section">
                <h3>Today's Summary</h3>
                <div className="detail-row">
                  <span className="label">Today's Hours:</span>
                  <span className="value">{profile.today_hours} hours</span>
                </div>
                <div className="detail-row">
                  <span className="label">Monthly Hours:</span>
                  <span className="value">{profile.monthly_hours} hours</span>
                </div>
                <div className="detail-row">
                  <span className="label">Current Status:</span>
                  <span className="value status-online">Online</span>
                </div>
              </div>

              {profile.home_address && (
                <div className="profile-section">
                  <h3>Contact Information</h3>
                  <div className="detail-row">
                    <span className="label">Home Address:</span>
                    <span className="value">{profile.home_address}</span>
                  </div>
                  <div className="detail-row">
                    <span className="label">Emergency Contact:</span>
                    <span className="value">{profile.emergency_contact_name} ({profile.emergency_contact_number})</span>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="error">Failed to load profile</div>
          )}
        </div>

        <div className="modal-actions">
          <button className="close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileModal;